<template lang="pug">
    Row(style="background-color: #eee;padding:20px" type="flex" justify="space-between")
        Col(span="11" v-for="item in themeTemplateItems" :key="item.name")
            Card.themeCard(:bordered="false"  style="min-height: 400px;max-height:800px;overflow: scroll"  dis-hover)
                pre(slot="title") {{item.name}}
                div(slot="extra")
                    Button(@click="editCustomizeTheme=true" icon="md-settings" v-if="item.name!=='Default'&&!editCustomizeTheme")
                    Button( @click="updateParent(item.value);currentTheme = item.value" :disabled="value == item.value||disabled" ) {{ value == item.value ? $t("groupPattern.applied"): $t("groupPattern.apply")}}
                div(style="width: 100%; display: flex; justify-content: center")
                    .theme_example(:style="item.cssProps")
                        .theme
                            .layout
                                .header
                                    .logo
                                    .globalSearch
                                .sider
                                    .sider_bg
                                    .selectedMenu
                                    .menuItem
                                    .subMenuTitle
                                .content
                                    .content_bg
                                    .contentArea
                                    .descriptionArea
                Modal(v-model="editCustomizeTheme" :scrollable="false" title="Edit Customize Theme Color" width="1000")
                    Row(style="display:flex;flex-direction:row;overflow-y:scroll;justify-content: space-evenly")
                        Col
                           .theme_example(:style="item.cssProps")
                                .theme
                                    .layout
                                        .header
                                            .logo
                                            .globalSearch
                                        .sider
                                            .sider_bg
                                            .selectedMenu
                                            .menuItem
                                            .subMenuTitle
                                        .content
                                            .content_bg
                                            .contentArea
                                            .descriptionArea
                        Col(style="margin-left: 10px")
                            .color_config
                                template(v-for="color in colorSet")
                                    .colorChip
                                        pre {{color.name}}
                                        pre {{customizeThemeColorSet[color.value]}}
                                        ColorPicker(v-model="customizeThemeColorSet[color.value]")
                    div(slot="footer")
                        Button(@click="updateCustomizeTheme(item.colorSet)" size="large" long :disabled="disabled" :type="!disabled?'primary':'default'") 更新
</template>
<script>
import { getGroupThemeColorSet, updateCustomizeThemeColorSet } from "@/api/group";

export default {
    props: ["groupName", "formItem", "formData", "value", "disabled"],
    data() {
        return {
            currentTheme: "Default",
            customizeThemeColorSet: {
                primaryColor: "#FBDCE9",
                fgColor: "#575559",
                bgColor: "#E7E3E2",
                tertColor: "#6A6C6C",
                darkPrimaryColor: "#989493",
                lightPrimaryColor: "#D9DCDD",
                headerColor: "#505051",
            },
            defaultThemeColorSet: {
                primaryColor: "#FBDCE9",
                fgColor: "#575559",
                bgColor: "#E7E3E2",
                tertColor: "#6A6C6C",
                darkPrimaryColor: "#989493",
                lightPrimaryColor: "#D9DCDD",
                headerColor: "#505051",
            },
            editCustomizeTheme: false,
            colorSet: [
                { value: "primaryColor", label: "Primary", name: "主色, 突顯色" },
                { value: "fgColor", label: "Foreground", name: "前景色, 側邊欄" },
                { value: "bgColor", label: "Background", name: "背景色, 主後背景" },
                { value: "tertColor", label: "Tert", name: "中間色, 側邊欄選項" },
                {
                    value: "darkPrimaryColor",
                    label: "Dark Primary",
                    name: "暗主色, 禁止選項, 輸入框提示",
                },
                {
                    value: "lightPrimaryColor",
                    label: "Light Primary",
                    name: "亮主色;hover",
                },
                { value: "headerColor", label: "Header", name: "頁首色" },
            ],
        };
    },
    methods: {
        updateParent(value) {
            this.$emit("input", value);
        },
        updateCustomizeTheme(colorSet) {
            updateCustomizeThemeColorSet({ colorSet: colorSet, groupName: this.groupName })
                .then((result) => {
                    this.$Notice.success({
                        title: this.$i18n.t("global.success"),
                        desc: `${result.data.message}`,
                    });
                    this.editCustomizeTheme = false;
                    this.getColorSet("customize", "customizeThemeColorSet");
                })
                .catch((err) => {
                    console.log(err);
                    this.$Notice.warning({
                        title: this.$i18n.t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
        getColorSet(type, colorSet) {
            getGroupThemeColorSet({ type: type, groupName: this.groupName })
                .then((result) => {
                    this[colorSet] = result.data.colorSet;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    created() {
        this.getColorSet("default", "defaultThemeColorSet");
        this.getColorSet("customize", "customizeThemeColorSet");
    },
    computed: {
        themeTemplateItems() {
            return [
                {
                    name: this.$i18n.t("groupPattern.default"),
                    value: 0,
                    cssProps: this.defaultCssProps,
                    colorSet: this.defaultThemeColorSet,
                },
                {
                    name: this.$i18n.t("groupPattern.customize"),
                    value: 1,
                    cssProps: this.customizeCssProps,
                    colorSet: this.customizeThemeColorSet,
                },
            ];
        },
        defaultCssProps() {
            return {
                "--primaryColor": this.defaultThemeColorSet.primaryColor,
                "--bgColor": this.defaultThemeColorSet.bgColor,
                "--darkPrimaryColor": this.defaultThemeColorSet.darkPrimaryColor,
                "--fgColor": this.defaultThemeColorSet.fgColor,
                "--headerColor": this.defaultThemeColorSet.headerColor,
                "--lightPrimaryColor": this.defaultThemeColorSet.lightPrimaryColor,
                "--tertColor": this.defaultThemeColorSet.tertColor,
                "--width": "360px",
                "--height": "256px",
                "--headerHeight": "16px",
                "--logoWidth": "35.25px",
                "--logoHeight": "9.25px",
                "--logoPositionTop": "3.5px",
                "--logoPositionLeft": "10.25px",
                "--globalSearchWidth": "106.25px",
                "--globalSearchHeight": "9.25px",
                "--globalSearchPositionTop": "3.5px",
                "--globalSearchPositionLeft": "134px",
                "--siderWidth": "55.75px",
                "--siderHeight": "240px",
                "--menuItemHeight": "13.25px",
                "--menuItemPositionTop": "26.5px",
                "--contentWidth": "304.25px",
                "--contentAreaWidth": "279.5px",
                "--contentPositionLeft": "12.5px",
                "--contentAreaHeight": "178.25px",
                "--contentAreaPositionTop": "46.75px",
                "--descriptionAreaHeight": "23.75px",
                "--descriptionAreaPositionTop": "11.75px",
            };
        },
        customizeCssProps() {
            return {
                "--primaryColor": this.customizeThemeColorSet.primaryColor,
                "--bgColor": this.customizeThemeColorSet.bgColor,
                "--darkPrimaryColor": this.customizeThemeColorSet.darkPrimaryColor,
                "--fgColor": this.customizeThemeColorSet.fgColor,
                "--headerColor": this.customizeThemeColorSet.headerColor,
                "--lightPrimaryColor": this.customizeThemeColorSet.lightPrimaryColor,
                "--tertColor": this.customizeThemeColorSet.tertColor,
                "--width": "360px",
                "--height": "256px",
                "--headerHeight": "16px",
                "--logoWidth": "35.25px",
                "--logoHeight": "9.25px",
                "--logoPositionTop": "3.5px",
                "--logoPositionLeft": "10.25px",
                "--globalSearchWidth": "106.25px",
                "--globalSearchHeight": "9.25px",
                "--globalSearchPositionTop": "3.5px",
                "--globalSearchPositionLeft": "134px",
                "--siderWidth": "55.75px",
                "--siderHeight": "240px",
                "--menuItemHeight": "13.25px",
                "--menuItemPositionTop": "26.5px",
                "--contentWidth": "304.25px",
                "--contentAreaWidth": "279.5px",
                "--contentPositionLeft": "12.5px",
                "--contentAreaHeight": "178.25px",
                "--contentAreaPositionTop": "46.75px",
                "--descriptionAreaHeight": "23.75px",
                "--descriptionAreaPositionTop": "11.75px",
            };
        },
    },
};
</script>
<style lang="less" scoped>
.colorChip {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.theme {
    overflow: hidden;
}
.theme {
    width: var(--width);
    height: var(--height);
    position: relative;
}
.layout {
    background-color: rgba(255, 255, 255, 1);
    width: var(--width);
    height: var(--height);
    position: relative;
    left: 0px;
    top: 0px;
}
.header {
    width: var(--width);
    height: var(--headerHeight);
    position: relative;
    left: 0px;
    top: 0px;
}
.header {
    background-color: var(--headerColor);
    width: var(--width);
    height: var(--headerHeight);
    position: relative;
    margin-left: 0px;
    margin-top: 0px;
}
.logo {
    background-color: rgba(155.12500405311584, 154.4786435365677, 154.4786435365677, 0.20000000298023224);
    width: var(--logoWidth);
    height: var(--logoHeight);
    position: absolute;
    left: var(--logoPositionLeft);
    top: var(--logoPositionTop);
}
.globalSearch {
    background-color: rgba(45.00000111758709, 45.00000111758709, 45.00000111758709, 0.800000011920929);
    width: var(--globalSearchWidth);
    height: var(--globalSearchHeight);
    position: absolute;
    left: var(--globalSearchPositionLeft);
    top: var(--globalSearchPositionTop);
}
.globalSearch {
    border: 0.5px solid var(--primaryColor);
}
.sider {
    width: var(--siderWidth);
    height: var(--siderHeight);
    position: absolute;
    left: 0px;
    top: var(--headerHeight);
}
.sider_bg {
    background-color: var(--fgColor);
    width: var(--siderWidth);
    height: var(--siderHeight);
    position: relative;
    margin-left: 0px;
    margin-top: 0px;
}
.selectedMenu {
    background-color: var(--primaryColor);
    width: var(--siderWidth);
    height: var(--menuItemHeight);
    position: absolute;
    left: 0px;
    top: var(--menuItemHeight);
}
.menuItem {
    background-color: var(--tertColor);
    width: var(--siderWidth);
    height: var(--menuItemHeight);
    position: absolute;
    left: 0px;
    top: var(--menuItemPositionTop);
}
.subMenuTitle {
    background-color: var(--fgColor);
    width: var(--siderWidth);
    height: var(--menuItemHeight);
    position: absolute;
    left: 0px;
    top: 0px;
}
.content {
    width: var(--contentWidth);
    height: var(--siderHeight);
    position: absolute;
    left: var(--siderWidth);
    top: var(--headerHeight);
}
.content_bg {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background-color: var(--bgColor);
    width: var(--contentWidth);
    height: var(--siderHeight);
    position: absolute;
    left: 0px;
    top: 0px;
}
.contentArea {
    background-color: rgba(255, 255, 255, 1);
    width: var(--contentAreaWidth);
    height: var(--contentAreaHeight);
    position: absolute;
    left: var(--contentPositionLeft);
    top: var(--contentAreaPositionTop);
}
.descriptionArea {
    background-color: rgba(255, 255, 255, 1);
    width: var(--contentAreaWidth);
    height: var(--descriptionAreaHeight);
    position: absolute;
    left: var(--contentPositionLeft);
    top: var(--descriptionAreaPositionTop);
}
</style>



// WEBPACK FOOTER //
// src/components/GroupPatternFormItems/ThemeSelector.vue